export customizeError = ({ code, message }) ->
  switch code
    when 101 then {
      code,
      message: "We couldn't find a user with that username/password combination."
    }
    when 100 then {
      code,
      message: "We couldn't connect to the server. Please check your internet connection."
    }
    when 212 then {
      code,
      message: "Invalid username or password."
    }
    when 216 then {
      code,
      message: "You have entered your password incorrectly too many times. Please ask an administrator to reset it for you."
    }
    else { code, message }
